/* CardsGoat · Lista completa de países para el creador de cartas.
   Fuente de verdad de países/banderas (el metafield custom.countries queda como fallback).
   Banderas: flagcdn.com (CORS habilitado, sirve para dibujar en canvas). */
window.CG_COUNTRIES = (function(){
  var POP = { es:1, ar:1, br:1, fr:1, 'gb-eng':1, de:1, it:1, pt:1, mx:1, us:1, ma:1, jp:1 };
  var C = {
    sudamerica: [
      ['ar','Argentina'],['bo','Bolivia'],['br','Brasil'],['cl','Chile'],['co','Colombia'],
      ['ec','Ecuador'],['gy','Guyana'],['py','Paraguay'],['pe','Perú'],['sr','Surinam'],
      ['uy','Uruguay'],['ve','Venezuela']
    ],
    norteamerica: [
      ['ag','Antigua y Barbuda'],['aw','Aruba'],['bs','Bahamas'],['bb','Barbados'],['bz','Belice'],
      ['bm','Bermudas'],['ca','Canadá'],['cr','Costa Rica'],['cu','Cuba'],['cw','Curazao'],
      ['dm','Dominica'],['sv','El Salvador'],['us','Estados Unidos'],['gd','Granada'],['gt','Guatemala'],
      ['ht','Haití'],['hn','Honduras'],['ky','Islas Caimán'],['jm','Jamaica'],['mx','México'],
      ['ni','Nicaragua'],['pa','Panamá'],['pr','Puerto Rico'],['do','República Dominicana'],
      ['kn','San Cristóbal y Nieves'],['vc','San Vicente y las Granadinas'],['lc','Santa Lucía'],
      ['tt','Trinidad y Tobago']
    ],
    europa: [
      ['al','Albania'],['de','Alemania'],['ad','Andorra'],['am','Armenia'],['at','Austria'],
      ['az','Azerbaiyán'],['be','Bélgica'],['by','Bielorrusia'],['ba','Bosnia y Herzegovina'],['bg','Bulgaria'],
      ['cz','Chequia'],['cy','Chipre'],['hr','Croacia'],['dk','Dinamarca'],['sk','Eslovaquia'],
      ['si','Eslovenia'],['es','España'],['ee','Estonia'],['gb-sct','Escocia'],['fi','Finlandia'],
      ['fr','Francia'],['gb-wls','Gales'],['ge','Georgia'],['gi','Gibraltar'],['gr','Grecia'],
      ['hu','Hungría'],['gb-eng','Inglaterra'],['ie','Irlanda'],['gb-nir','Irlanda del Norte'],['is','Islandia'],
      ['fo','Islas Feroe'],['il','Israel'],['it','Italia'],['kz','Kazajistán'],['xk','Kosovo'],
      ['lv','Letonia'],['li','Liechtenstein'],['lt','Lituania'],['lu','Luxemburgo'],['mk','Macedonia del Norte'],
      ['mt','Malta'],['md','Moldavia'],['mc','Mónaco'],['me','Montenegro'],['no','Noruega'],
      ['nl','Países Bajos'],['pl','Polonia'],['pt','Portugal'],['ro','Rumania'],['ru','Rusia'],
      ['sm','San Marino'],['rs','Serbia'],['se','Suecia'],['ch','Suiza'],['tr','Turquía'],['ua','Ucrania']
    ],
    africa: [
      ['dz','Argelia'],['ao','Angola'],['bj','Benín'],['bw','Botsuana'],['bf','Burkina Faso'],
      ['bi','Burundi'],['cv','Cabo Verde'],['cm','Camerún'],['td','Chad'],['km','Comoras'],
      ['cg','Congo'],['ci','Costa de Marfil'],['eg','Egipto'],['er','Eritrea'],['sz','Esuatini'],
      ['et','Etiopía'],['ga','Gabón'],['gm','Gambia'],['gh','Ghana'],['gn','Guinea'],
      ['gw','Guinea-Bisáu'],['gq','Guinea Ecuatorial'],['ke','Kenia'],['ls','Lesoto'],['lr','Liberia'],
      ['ly','Libia'],['mg','Madagascar'],['mw','Malaui'],['ml','Malí'],['ma','Marruecos'],
      ['mu','Mauricio'],['mr','Mauritania'],['mz','Mozambique'],['na','Namibia'],['ne','Níger'],
      ['ng','Nigeria'],['cf','República Centroafricana'],['cd','RD Congo'],['rw','Ruanda'],
      ['st','Santo Tomé y Príncipe'],['sn','Senegal'],['sc','Seychelles'],['sl','Sierra Leona'],
      ['so','Somalia'],['za','Sudáfrica'],['sd','Sudán'],['ss','Sudán del Sur'],['tz','Tanzania'],
      ['tg','Togo'],['tn','Túnez'],['ug','Uganda'],['dj','Yibuti'],['zm','Zambia'],['zw','Zimbabue']
    ],
    asia: [
      ['af','Afganistán'],['sa','Arabia Saudita'],['bh','Baréin'],['bd','Bangladés'],['bt','Bután'],
      ['bn','Brunéi'],['kh','Camboya'],['qa','Catar'],['cn','China'],['kp','Corea del Norte'],
      ['kr','Corea del Sur'],['ae','Emiratos Árabes Unidos'],['ph','Filipinas'],['hk','Hong Kong'],['in','India'],
      ['id','Indonesia'],['iq','Irak'],['ir','Irán'],['jp','Japón'],['jo','Jordania'],
      ['kg','Kirguistán'],['kw','Kuwait'],['la','Laos'],['lb','Líbano'],['my','Malasia'],
      ['mv','Maldivas'],['mn','Mongolia'],['mm','Myanmar'],['np','Nepal'],['om','Omán'],
      ['pk','Pakistán'],['ps','Palestina'],['sg','Singapur'],['sy','Siria'],['lk','Sri Lanka'],
      ['th','Tailandia'],['tw','Taiwán'],['tj','Tayikistán'],['tl','Timor Oriental'],['tm','Turkmenistán'],
      ['uz','Uzbekistán'],['vn','Vietnam'],['ye','Yemen']
    ],
    oceania: [
      ['au','Australia'],['fj','Fiyi'],['ck','Islas Cook'],['mh','Islas Marshall'],['sb','Islas Salomón'],
      ['ki','Kiribati'],['fm','Micronesia'],['nr','Nauru'],['nc','Nueva Caledonia'],['nz','Nueva Zelanda'],
      ['pw','Palaos'],['pg','Papúa Nueva Guinea'],['pf','Polinesia Francesa'],['ws','Samoa'],['to','Tonga'],
      ['tv','Tuvalu'],['vu','Vanuatu']
    ]
  };
  var out = [];
  Object.keys(C).forEach(function(cont){
    C[cont].forEach(function(p){
      out.push({ id:p[0], name:p[1], flag:'https://flagcdn.com/w80/'+p[0]+'.png', continent:cont, popular:!!POP[p[0]] });
    });
  });
  return out;
})();
